"use client";

import { redirectWithDelay } from "@/utils/functions/redirectWithDelay";
import { getEnv } from "@/env";
import { useRouter } from "next/navigation";

type Props = {
  redirectUrl: string;
  finishAuthUrl?: string | null;

  success: boolean;
  currentProvider?: string | null;
  cohesionCallback?: () => void;
};

// analog of the same class in AuthN
export default function RedirectLogistration({
  finishAuthUrl,
  redirectUrl,
  success,
  currentProvider,
  cohesionCallback,
}: Props) {
  const router = useRouter();
  const baseUrl = new URL(getEnv("NEXT_PUBLIC_LMS_BASE_URL"));
  if (success && redirectUrl) {
    if (!currentProvider) {
      cohesionCallback?.();
    }

    let finalRedirectUrl = "";
    if (finishAuthUrl && !redirectUrl.includes(finishAuthUrl)) {
      finalRedirectUrl = `${baseUrl}${finishAuthUrl}`;
    } else {
      finalRedirectUrl = redirectUrl;
    }

    try {
      redirectWithDelay(router, finalRedirectUrl);
    } catch (error) {
      if (typeof window !== "undefined" && window.newrelic) {
        window.newrelic.noticeError(error as Error, {
          submodule: "logistration",
          context: "redirectValidation",
          invalidUrl: finalRedirectUrl,
          provider: currentProvider || "password",
          hasFinishAuthUrl: !!finishAuthUrl,
          timestamp: new Date().toISOString(),
        });
      }
    }
  }
  return null;
}
